module.exports = __webpack_public_path__ + "img/general-6.2.2b13e7c4.svg";